var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBlockchain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 37.4028C24.42 37.4028 24.8085 37.2241 25.587 36.8652L31.845 33.9885C34.6155 32.7148 36 32.0772 36 31.0695V18.4028M24 37.4028C23.58 37.4028 23.1915 37.2241 22.413 36.8652L16.155 33.9885C13.3845 32.7148 12 32.0772 12 31.0695V18.4028M24 37.4028V24.7362",
    stroke: "#4776E6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.413 11.9546C23.193 11.5863 23.5815 11.4028 24 11.4028C24.42 11.4028 24.8085 11.5863 25.587 11.9546L31.845 14.9071C34.6155 16.2143 36 16.8686 36 17.9028C36 18.9371 34.6155 19.5914 31.845 20.8986L25.587 23.8511C24.807 24.2194 24.4185 24.4028 24 24.4028C23.58 24.4028 23.1915 24.2194 22.413 23.8511L16.155 20.8986C13.3845 19.5914 12 18.9371 12 17.9028C12 16.8686 13.3845 16.2143 16.155 14.9071L22.413 11.9546Z",
    stroke: "#4776E6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBlockchain);
export default __webpack_public_path__ + "static/media/ic-blockchain.fbce0682601859a9347e04a1207267de.svg";
export { ForwardRef as ReactComponent };